import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../../../shared/services/dashboard.service';

@Component({
  selector: 'flow-tracking-cards',
  templateUrl: './flow-tracking-cards.component.html',
  styleUrls: ['./flow-tracking-cards.component.scss']
})
export class FlowTrackingCardsComponent implements OnInit {

  public action: string = '';
  
  public kpi_cards = [
    { key: "Today's received volume (litre)", value: '' },
    { key: 'Monthly received volume (litre)', value: '' },
    { key: 'Yearly received volume (litre)', value: '' },
    { key: 'Last delivery', value: '' }
  ];

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.getFlowTrackingCards();
  }

  getBody() {
    let body = {
      "action": this.action,
      "user_id": [localStorage.getItem('user')]
    }
    return body;
  }

  getFlowTrackingCards() {
    this.action = 'getFlowTrackingCards';
    this.dashboardService.httpPost(this.getBody()).subscribe((res: any) => {
      let data = res.data;
      this.kpi_cards[0].value = data.daily;
      this.kpi_cards[1].value = data.monthly;
      this.kpi_cards[2].value = data.yearly;
      this.kpi_cards[3].value = data.last_receive_volume;
    })
   
  }
}
